<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文档" prop="docUrl">
              <j-upload v-model="model.docUrl" @change="fileUploadChange"></j-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文档名称" prop="docName">
              <a-input placeholder="请输入文档名称" v-model="model.docName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日期" prop="docDate">
              <j-date placeholder="请选择日期" style="width: 100%" v-model="model.docDate" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="存档日期" prop="saveDate">
              <j-date placeholder="请选择存档日期" style="width: 100%" v-model="model.saveDate" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" prop="manager">
              <j-dict-select-tag
                :dictCode="sysPersonDictCode"
                placeholder="请选择负责人"
                type="list"
                v-model="model.manager"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" prop="remark">
              <a-textarea placeholder="请输入备注" rows="4" v-model="model.remark" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import moment from 'dayjs'

export default {
  name: 'CommonDocsForm',
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      sysPersonDictCode: `sys_user,realname,id,rel_tenant_ids='${this.$ls.get('TENANT_ID')}'`,
      model: {
        docType: 'A03',
        docDate: moment().format('YYYY-MM-DD'),
        saveDate: moment().format('YYYY-MM-DD'),
        manager: this.$store.getters.userInfo.id
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      confirmLoading: false,
      validatorRules: {
        docName: [{ required: true, message: '请输入文档名称!' }],
        docUrl: [{ required: true, message: '请上传文档!' }],
        docDate: [{ required: true, message: '请输入日期!' }]
      },
      url: {
        add: '/doc/commonDocs/add',
        edit: '/doc/commonDocs/edit',
        queryById: '/doc/commonDocs/queryById'
      }
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    }
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    fileUploadChange(filePath) {
      if (!filePath) {
        this.model.docName = ''
        return
      }
      const fileName = filePath.split('/').pop()
      this.model.docName = this.model.docName || fileName
      this.$refs.form.clearValidate('docName')
    },
    add(docType) {
      this.modelDefault.docType = docType
      this.edit(this.modelDefault)
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
